import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	visible: false,
	isError: false,
	isSuccess: false,
	resultCode: null,
	message: null,
}

export const messageBoxSlice = createSlice({
	name: "messageBox",
	initialState,
	reducers: {
        fetchMessageBoxRequest: () => {},
        fetchSuccessMessageBoxRequest: () => {},
        fetchErrorMessageBoxRequest: () => {},

        fetchMessageBoxOn: (state, action) => {
			state.visible    = true;
			state.isError    = action.payload.isError    ?? false;
			state.isSuccess  = action.payload.isSuccess  ?? false;
			state.resultCode = action.payload.resultCode ?? null;
			state.message    = action.payload.message    ?? null;
		},
        fetchMessageBoxOff: (state) => {
            Object.assign(state,initialState);
        }
    },
})

export const {
	fetchMessageBoxRequest,
    fetchSuccessMessageBoxRequest,
    fetchErrorMessageBoxRequest,
    fetchMessageBoxOn,
    fetchMessageBoxOff,
} = messageBoxSlice.actions

export default messageBoxSlice.reducer;